module.exports = __webpack_public_path__ + "img/bocht-geen-afm.15a65343.jpg";